export default __webpack_public_path__ + "static/media/ideal.54bdef94.gif";